// HEIC/HEIF -> JPEG in the browser. heic2any (libheif wasm) is ~1 MB, so it is not part of
// editor.js: an IIFE bundle cannot code-split, so the UMD build sits next to editor.js and is
// loaded with a <script> tag the first time a HEIC file is picked.

import { ASSET_BASE } from './assets';

declare global {
  interface Window { heic2any?: (o: { blob: Blob; toType: string; quality: number }) => Promise<Blob | Blob[]> }
}

let loading: Promise<void> | null = null;
function loadDecoder(): Promise<void> {
  if (window.heic2any) return Promise.resolve();
  loading ??= new Promise((resolve, reject) => {
    const s = document.createElement('script');
    s.src = `${ASSET_BASE}/heic2any.min.js`;
    s.onload = () => resolve();
    s.onerror = () => { loading = null; reject(new Error('heic2any failed to load')); };
    document.head.appendChild(s);
  });
  return loading;
}

export async function heicToJpeg(file: File): Promise<File> {
  await loadDecoder();
  const out = await window.heic2any!({ blob: file, toType: 'image/jpeg', quality: 0.92 });
  const blob = Array.isArray(out) ? out[0] : out;
  return new File([blob], file.name.replace(/\.hei[cf]$/i, '') + '.jpg', { type: 'image/jpeg' });
}
